import { useEffect } from 'react'
import { useLocale } from '../i18n/LocaleProvider'

/** Pass an empty suffix to use the title as a complete page title. */
export function usePageTitle(title?: string, suffix?: string, translateTitle = true) {
  const { locale, t } = useLocale()
  const brand = locale === 'ja' ? 'バイバイト株式会社' : 'Bybeit'
  const resolvedSuffix = suffix ?? brand
  useEffect(() => {
    document.title = title ? `${translateTitle ? t(title) : title}${resolvedSuffix ? ` — ${resolvedSuffix}` : ''}` : brand
    return () => { document.title = brand }
  }, [title, resolvedSuffix, brand, t, translateTitle])
}
